<template>
  <article>
    <div class="">
      <div class="fs-18 fc-blue">基本信息：</div>
      <div class="dataForm mt-20 ml-40">
        <div class="dataForm__item">
          <div class="dataForm__name">ID</div>
          <el-input v-model="detail.sgid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
        </div>
        <div class="dataForm__item mt-20">
          <div class="dataForm__name ml40">分类</div>
          <el-select placeholder="请选择" v-model="detail.scid">
            <el-option :label="item.title" :value="item.scid" v-for="(item, index) in categoryLists" :key="index"></el-option>
          </el-select>
        </div>
        <div class="dataForm__item mt-16">
          <div class="dataForm__name">标题</div>
          <el-input v-model="detail.title" placeholder="" size="mini" class="dataForm__input"></el-input>
        </div>
        <div class="dataForm__item mt-16">
          <div class="dataForm__name">渠道ID</div>
          <el-input v-model="detail.chnid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
        </div>
        <div class="dataForm__item mt-20">
          <div class="dataForm__name ml40">icon</div>
          <div class="headimg-container relative" style="width:250px">
            <uploadHeadImage :url.sync="detail.icon" :itype="5"></uploadHeadImage>
          </div>
        </div>
        <div class="dataForm__item mt-16">
          <div class="dataForm__name">权重</div>
          <el-input v-model="detail.weight" placeholder="" size="mini" class="dataForm__input"></el-input>
        </div>
        <div class="dataForm__item mt-20">
          <div class="dataForm__name ml40">横幅图</div>
          <div class="headimg-container relative" style="width:250px">
            <uploadImageList :list.sync="detail.banners" :itype="5" :width="400" @uploadMultipleSuccess="uploadMultipleSuccess"></uploadImageList>
          </div>
        </div>
        <div class="dataForm__item mt-20">
          <div class="dataForm__name ml40">介绍图</div>
          <div class="headimg-container relative" style="width:250px">
            <uploadImageList :list.sync="detail.intros" :itype="5" :width="400" @uploadMultipleSuccess="uploadMultipleSuccessIntros"></uploadImageList>
          </div>
        </div>
        <div class="dataForm__item mt-16">
          <div class="dataForm__name">状态</div>
          <el-radio-group v-model="detail.status">
            <div class="dib mr-20">
              <el-radio :label="item.value" v-for="(item, index) in statusList" :key="index">{{item.name}}</el-radio>
            </div>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="mt-20">
      <div class="fs-18 fc-blue">库存/规格：</div>
      <div class="fs16 mt-20 ml-40">
        <div class="mt-20">
          <div class="dataForm__item">
            <div class="dataForm__name">总库存：</div>
            <div class="shop-feature-choice">
              <div v-for="(featureItem, index) in featureLists" :key="index">
                <div class="dataForm__item mb-20 bgc-gray">
                  <div class="dataForm__name">规格：</div>
                  <el-select placeholder="请选择" v-model="featureItem.fcid" @change="selFeatureItem(index)">
                    <el-option v-for="item in featureCategoryLists" :key="item.fcid" :label="item.category" class="dataForm__input"  :value="item.fcid"> </el-option>
                  </el-select>
                  <div class="ml-20" v-if="index === 0">
                    <el-checkbox v-model="setFeatureImage">添加规格图片</el-checkbox>
                  </div>
                  <el-button type="danger" class="ml-40" size="mini" icon="el-icon-delete" circle @click="delFeatureItem(index)"></el-button>
                </div>
                <div class="dataForm__item mb-20">
                  <div class="dataForm__name">特征：</div>
                  <el-select multiple filterable placeholder="请选择" v-model="featureItem.faids" @change="initFeatureImage(index)">
                    <el-option v-for="item in featureAttribute[featureItem.fcid]" :key="item.faid"
                               :label="item.attribute" class="dataForm__input"  :value="item.faid">
                    </el-option>
                  </el-select>
                  <el-button v-if="featureItem.fcid !== ''" @click="editShopFeatureAttributes(featureItem.fcid)"
                             type="primary" class="ml-10" size="mini" icon="el-icon-edit" circle></el-button>
                </div>
                <div class="dataForm__item mb-20"  v-if="index === 0 && setFeatureImage">
                  <div v-for="imageItem in featureItem.attributes" :key="imageItem.faid">
                    <div class="fw ml-30">
                      <uploadHeadImage :url.sync="imageItem.icon" :itype="5"></uploadHeadImage>
                      <el-button type="primary" class="mt-5 ml-5" plain size="mini">{{imageItem.attribute}}</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dataForm__item">
                <el-button size="mini" @click="addFeatureItem" :disabled="featureLists.length > 2">添加规格项目</el-button>
                <el-button size="mini" @click="featureDialog = !featureDialog">新建规格项目</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="db mt-20">
          <div class="dataForm__item fw">
            <div class="dataForm__name">规格明细：</div>
            <div class="shop-feature-choice">
              <div class="dataForm__item">
                <el-table ref="dataTable" :data="stockLists" highlight-current-row style="width: 100%;" size="mini" class="">
                  <el-table-column prop="gsid" label="库存ID" width="" align="center">
                  </el-table-column>
                  <el-table-column
                    v-for="item in featureLists"
                    :key="item.fcid"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    align="center"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column prop="" label="发货时间" width="" align="center">
                  </el-table-column>
                  <el-table-column prop="min_price" label="成本价" width="" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.min_price" size="mini" @input="(v)=>(scope.row.min_price=v.replace(/[^\d.]/g,''))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="销售价" width="" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.price" size="mini" @input="(v)=>(scope.row.price=v.replace(/[^\d.]/g,''))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="total" label="库存" width="" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.total" size="mini" @input="(v)=>(scope.row.total=v.replace(/[^\d]/g,''))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="weight" label="重量" width="" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.weight" size="mini" @input="(v)=>(scope.row.weight=v.replace(/[^\d.]/g,''))"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sold" label="已售" width="" align="center">
                  </el-table-column>
                </el-table>
              </div>
              <div class="dataForm__item mt-20" v-for="(item, index) in featureLists" :key="item.fcid">
                <el-checkbox
                    :indeterminate="item.isIndeterminate"
                    v-model="item.checkAll"
                    @change="(val) => handleCheckAllChange(val, index)">
                    {{mapFeatureName[item.fcid]}}
                </el-checkbox>
                <div class="ml-30">
                  <el-checkbox-group v-model="item.checkedAttributes" @change="(val) => handleCheckedAttributesChange(val, index)">
                    <el-checkbox v-for="faid in item.faids" :label="faid" :key="faid">{{mapAttributeName[faid]}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <div class="dataForm__item mt-20">
                <div class="mr-20">批量修改</div>
                <el-input v-model="featureMultiInfo.min_price" class="mr-20" style="width:70px"  @input="(v)=>(featureMultiInfo.min_price=v.replace(/[^\d.]/g,''))" placeholder="成本价" size="mini"></el-input>
                <el-input v-model="featureMultiInfo.price" class="mr-20" style="width:70px"  @input="(v)=>(featureMultiInfo.price=v.replace(/[^\d.]/g,''))" placeholder="销售价" size="mini"></el-input>
                <el-input v-model="featureMultiInfo.total" class="mr-20" style="width:70px" @input="(v)=>(featureMultiInfo.total=v.replace(/[^\d]/g,''))"  placeholder="库存" size="mini"></el-input>
                <el-input v-model="featureMultiInfo.weight" class="mr-20" style="width:70px" @input="(v)=>(featureMultiInfo.weight=v.replace(/[^\d.]/g,''))" placeholder="重量" size="mini"></el-input>
                <el-button size="mini" @click="featureMultiUpdate">确定</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-20">
          <div class="dataForm__item">
            <div class="dataForm__name">总库存：</div>
            <el-input v-model="detail.total" placeholder="" size="mini" class="dataForm__input"  @input="(v)=>(detail.total=v.replace(/[^\d]/g,''))"></el-input>
          </div>
        </div>
        <div class="mt-20">
          <div class="dataForm__item">
            <div class="dataForm__name">价格：</div>
            <el-input placeholder="" v-model="detail.price" class="mr-20" style="width:200px" size="mini" @input="(v)=>(detail.price=v.replace(/[^\d.]/g,''))">
              <template slot="prepend">销售价￥</template>
            </el-input>
            <el-input placeholder="" v-model="detail.origin_price" class="mr-20" style="width:200px" size="mini" @input="(v)=>(detail.origin_price=v.replace(/[^\d.]/g,''))">
              <template slot="prepend">原价￥</template>
            </el-input>
            <el-input placeholder="" v-model="detail.min_price" class="mr-20" style="width:200px" size="mini" @input="(v)=>(detail.min_price=v.replace(/[^\d.]/g,''))">
              <template slot="prepend">成本价￥</template>
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-20">
      <div class="fs-18 fc-blue">物流/其他：</div>
      <div class="dataForm mt-20 ml-40">
        <div class="dataForm__item mt-16">
          <div class="dataForm__name">邮费</div>
          <el-input v-model="detail.post" placeholder="" size="mini" class="dataForm__input" @input="(v)=>(detail.post=v.replace(/[^\d.]/g,''))"></el-input>
        </div>
      </div>
    </div>
    <div class="mt-20">
      <div class="dataForm">
        <div class="dataForm__item mt-16">
          <div class="dataForm__name"></div>
          <button class="blue-large-btn" @click="shopGoodsEdit">保存</button>
        </div>
      </div>
    </div>
    <el-dialog title="特征编辑" :visible.sync="featureDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">特征ID</div>
            <el-input v-model="featureInfo.fcid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">特征名</div>
            <el-input v-model="featureInfo.category" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="shopFeatureCategoryEdit">保存</div>
          <div class="gray-large-btn" @click="featureDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="创建属性" :visible.sync="attributeDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">特征ID</div>
            <div>{{featureAttributeInfo.fcid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">特征名</div>
            <div>{{featureAttributeInfo.category}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">权重</div>
            <el-input v-model="featureAttributeInfo.weight" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">属性</div>
            <el-input type="textarea" v-model="featureAttributeInfo.attributes" rows=4 placeholder="用|分割数据，例如37码|38码" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="shopFeatureAttributeMultiCreate">保存</div>
          <div class="gray-large-btn" @click="attributeDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import util from '../../../script/util'
import {shopGoodsDetail, shopGoodsEdit, shopCategoryLists, shopFeatureCategoryLists, shopFeatureCategoryEdit, shopFeatureAttributeMultiCreate} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
import uploadImageList from '../../../components/uploadMultipleImageList.vue'
export default {
  name: 'shopGoodsEdit',
  components: {
    uploadHeadImage,
    uploadImageList
  },
  data () {
    return {
      detail: {
        sgid: 0,
        title: '',
        icon: '',
        scid: '',
        chnid: 1,
        feature: '',
        attributes: '',
        min_price: '',
        origin_price: '',
        price: '',
        post: '',
        total: '',
        weight: 0,
        banners: [],
        intros: [],
        desc: '',
        status: 1
      },
      categoryLists: [],
      featureLists: [],
      setFeatureImage: false,
      featureDialog: false,
      attributeDialog: false,
      listLoading: false,
      featureAttribute: {
        '请选择': []
      },
      featureCategoryLists: [],
      featureAttributeLists: [],
      mapAttributeName: {},
      mapFeatureName: {},
      featureMultiInfo: {
        min_price: '',
        price: '',
        total: '',
        weight: ''
      },
      stockLists: [],
      featureInfo: {
        fcid: 0,
        category: ''
      },
      featureAttributeInfo: {
        fcid: 0,
        weight: 0,
        category: '',
        attributes: ''
      },
      props: { multiple: true },
      dialog: false,
      statusList: [
        {
          name: '正常',
          value: 1
        },
        {
          name: '停止',
          value: 0
        }
      ]
    }
  },
  methods: {
    handleCheckAllChange (val, index) {
      this.featureLists[index].checkedAttributes = val ? this.featureLists[index].faids.slice() : []
      this.featureLists[index].isIndeterminate = false
    },
    handleCheckedAttributesChange (value, index) {
      let checkedCount = value.length
      this.featureLists[index].checkAll = checkedCount === this.featureLists[index].faids.length
      this.featureLists[index].isIndeterminate = checkedCount > 0 && checkedCount < this.featureLists[index].faids.length
    },
    uploadMultipleSuccess (data) {
      this.detail.banners = data
    },
    uploadMultipleSuccessIntros (data) {
      this.detail.intros = data
    },
    addFeatureItem () {
      this.featureLists.push({
        fcid: '',
        category: '',
        faids: [],
        attributes: [],
        label: '',
        prop: '',
        checkAll: false,
        checkedAttributes: [],
        isIndeterminate: true
      })
    },
    delFeatureItem (index) {
      this.featureLists.splice(index, 1)
    },
    selFeatureItem (index) {
      let fcid = this.featureLists[index].fcid

      // 排重相同规格
      for (let key in this.featureLists) {
        if (parseInt(key) !== parseInt(index) && this.featureLists[key].fcid === fcid) {
          this.featureLists[index].fcid = ''

          this.$notify({
            title: '失败，重复选择规格',
            type: 'error'
          })
          return
        }
      }
      this.featureLists[index].category = this.mapFeatureName[fcid]
      this.featureLists[index].faids = []
      this.featureLists[index].attributes = []
      this.featureLists[index].label = this.mapFeatureName[fcid]
      this.featureLists[index].prop = 'feature-' + fcid
    },
    initFeatureImage (index) {
      let feature = this.featureLists[index]

      // 保存之前配置的图片
      let tempMap = {}
      feature.attributes.forEach(item => {
        tempMap[item['faid']] = item
      })

      feature.attributes = []
      feature.faids.forEach((faid, index) => {
        let final = {
          faid: faid,
          attribute: this.mapAttributeName[faid],
          icon: ''
        }

        if (tempMap.hasOwnProperty(faid)) {
          final = tempMap[faid]
        }

        feature.attributes.push(final)
      })

      this.generateStock()
    },
    generateStock () {
      let featureKeyLists = [
        {
          categoryKey: [],
          category: [],
          featureKey: [],
          content: []
        }
      ]

      for (let key in this.featureLists) {
        let row = this.featureLists[key]

        if (row['fcid'] === '' || row.faids.length === 0) {
          continue
        }

        let tempLists = []
        row.faids.forEach(faid => {
          for (let index in featureKeyLists) {
            let item = featureKeyLists[index]

            let final = {
              featureKey: item['featureKey'].concat([faid]),
              content: item['content'].concat([this.mapAttributeName[faid]]),
              categoryKey: item['categoryKey'].concat([row['fcid']]),
              category: item['category'].concat([this.mapFeatureName[row['fcid']]])
            }
            tempLists.push(final)
          }
        })

        // 交换列表
        featureKeyLists = tempLists
      }

      let tempMap = {}
      this.stockLists.forEach(item => {
        let key = item.featureKey.join('-')
        tempMap[key] = item
      })

      let tempLists = []
      featureKeyLists.forEach(item => {
        let final = {
          gsid: 0,
          min_price: '',
          price: '',
          total: 0,
          weight: 0,
          sold: 0,
          category: item.category,
          categoryKey: item.categoryKey,
          content: item.content,
          featureKey: item.featureKey
        }
        for (let index in item.categoryKey) {
          let key = 'feature-' + item.categoryKey[index]
          final[key] = item.content[index]
        }

        let key = final.featureKey.join('-')
        if (tempMap.hasOwnProperty(key)) {
          final = tempMap[key]
        }

        tempLists.push(final)
      })

      this.stockLists = tempLists
    },
    featureMultiUpdate () {
      this.featureLists.forEach(item => {
        item.checkedAttributes.forEach(faid => {
          this.stockLists.forEach(row => {
            console.log('faid', faid, row)
            if (row.featureKey.includes(faid)) {
              for (let key in this.featureMultiInfo) {
                if (this.featureMultiInfo[key] !== '') {
                  row[key] = this.featureMultiInfo[key]
                }
              }
            }
          })
        })
      })
    },
    getCategoryLists () {
      let params = {
      }

      this.listLoading = true
      shopCategoryLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.categoryLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.scid + ')',
              scid: item.scid
            }
          })
        }
      })
    },
    getFeatureCategoryLists () {
      let params = {
      }

      this.listLoading = true
      shopFeatureCategoryLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.featureCategoryLists = data.d.lists.map((item, index) => {
            let children = item.attribute_lists.map((row, x) => {
              this.mapAttributeName[row.faid] = row.attribute
              return {
                value: row.faid,
                label: row.attribute
              }
            })
            this.mapFeatureName[item.fcid] = item.category
            return {
              category: item.category + '(' + item.fcid + ')',
              fcid: item.fcid,
              value: item.fcid,
              label: item.category,
              children: children
            }
          })
          data.d.lists.map((item, index) => {
            this.featureAttribute[item.fcid] = []
            item.attribute_lists.map((row, x) => {
              this.featureAttribute[item.fcid].push({
                faid: row.faid,
                attribute: row.attribute + '(' + row.faid + ')',
                icon: ''
              })
            })
          })
        }
      })
    },
    // 公众号详情
    shopGoodsDetail () {
      let params = {
        sgid: this.detail.sgid
      }

      this.loading = true
      shopGoodsDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d
          console.log('detail---', this.detail)

          this.featureLists = []
          this.stockLists = data.d.stock_lists

          this.stockLists.forEach(item => {
            for (let index in item.categoryKey) {
              let key = 'feature-' + item.categoryKey[index]
              item[key] = item.content[index]
            }
          })

          data.d.feature_lists.forEach(item => {
            item.attributes.forEach(row => {
              if (row['icon'] !== '') {
                this.setFeatureImage = true
              }
            })

            this.featureLists.push({
              fcid: item.fcid,
              category: item.category,
              faids: item.faids,
              attributes: item.attributes,
              label: item.category,
              prop: 'feature-' + item.fcid,
              checkAll: false,
              checkedAttributes: [],
              isIndeterminate: true
            })
          })
        }
        this.loading = false
      })
    },
    editShopFeatureAttributes (fcid) {
      this.featureAttributeInfo = {
        fcid: fcid,
        category: this.mapFeatureName[fcid],
        weight: 0,
        attributes: ''
      }
      this.attributeDialog = true
    },
    shopFeatureAttributeMultiCreate (fcid) {
      let params = {
        fcid: this.featureAttributeInfo.fcid,
        category: this.featureAttributeInfo.category,
        weight: this.featureAttributeInfo.weight,
        attributes: this.featureAttributeInfo.attributes
      }

      let content = ''

      if (params['attributes'] === '') {
        content = '请填写属性'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      shopFeatureAttributeMultiCreate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.attributeDialog = false
          this.getFeatureCategoryLists()

          for (let key in this.featureAttributeInfo) {
            this.featureAttributeInfo[key] = ''
          }
          this.featureAttributeInfo.weight = 0
          this.featureAttributeInfo.attributes = ''
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    shopFeatureCategoryEdit () {
      let params = {
        fcid: this.featureInfo.fcid,
        category: this.featureInfo.category
      }

      shopFeatureCategoryEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.featureDialog = false
          this.getFeatureCategoryLists()

          for (let key in this.featureInfo) {
            this.featureInfo[key] = ''
          }
          this.featureInfo.fcid = 0
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    shopGoodsEdit () {
      let params = util.cloneObj(this.detail)

      params['intros'] = params['intros'].join('|')
      params['banners'] = params['banners'].join('|')

      console.log(params)

      let content = ''

      if (this.featureLists.length === 0) {
        content = '请选择规格'
      }
      this.featureLists.forEach(item => {
        if (item.fcid === 0 || item.faids.length === 0) {
          content = '请选择规格或者特征'
        }
      })

      this.stockLists.forEach(item => {
        if (item.price === '' || item.min_price === '') {
          content = '请设置销售价和成本价'
        }
      })

      if (params['title'] === '') {
        content = '没有填写标题'
      }

      if (params['scid'] === '') {
        content = '没有选择分类'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      // 规格和特征
      params['feature'] = JSON.stringify({'lists': this.featureLists})

      // 库存
      params['stock'] = JSON.stringify({'lists': this.stockLists})

      console.log('params', params)

      shopGoodsEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/shopGoodsList')
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    },
    beforeunloadHandler (e) {
      if (!this.detail.sgid) {
        util.setCookie('createAddetail', JSON.stringify(this.detail))
      }
    }
  },
  watch: {
  },
  destroyed () {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
  },
  mounted () {
    this.detail.sgid = parseInt(this.$route.query.sgid || 0)
    if (this.detail.sgid) {
      this.shopGoodsDetail()
    } else {
      let createAddetail = util.getCookie('createAddetail')
      if (createAddetail) {
        createAddetail = JSON.parse(createAddetail)
        this.detail = util.cloneObj(createAddetail)
      }
    }
    this.getCategoryLists()
    this.getFeatureCategoryLists()
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  }
}
</script>

<style lang="scss" scoped>
.shop-feature-choice {
  height: 100%;
  width: 1000px;
  background-color: #fff;
  padding: 10px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  // display: flex;
  // flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopGoodsEdit.vue